import ReactDOM from 'react-dom/client';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

import { loadOrgOverrides } from './lib/orgOverrides';
import './custom/registry';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

const root = ReactDOM.createRoot(container);

// Overlay chunks load only for registered orgs. Wait so Header/theme never
// flash the generic shell, then import App so module-level readers see cache.
loadOrgOverrides()
  .catch(() => null)
  .then(() => import('./App'))
  .then(({ default: App }) => {
    root.render(<App />);
  });
